import { ApolloClient, createHttpLink, gql, InMemoryCache, TypedDocumentNode } from '@apollo/client';
import {
    Mutation,
    MutationExecuteStepArgs,
    MutationSaveWorkflowArgs,
    Query,
    QueryWorkflowArgs
} from 'sr-types/lib/workflow/v1/graphql';
import { authLink } from '../../auth/api';
import { ContactInfoFragment, NameFragment, ReferenceFragment } from '../../list/fragments';

export const workflowGraphqlClient = new ApolloClient({
    link: authLink.concat(
        createHttpLink({
            uri: '/workflow/v1/'
        })
    ),
    cache: new InMemoryCache({
        addTypename: false
    })
});

export const saveWorkflowMutation: TypedDocumentNode<Pick<Mutation, 'saveWorkflow'>, MutationSaveWorkflowArgs> = gql`
    mutation SaveWorkflow($input: WorkflowInfoInput!, $initiate: Boolean) {
        saveWorkflow(input: $input, initiate: $initiate) {
            id
            reference {
                ...Reference
            }
            errors {
                field
                key
                message
            }
        }
    }
    ${ReferenceFragment}
`;

export const executeWorkflowStepMutation: TypedDocumentNode<
    Pick<Mutation, 'executeStep'>,
    MutationExecuteStepArgs
> = gql`
    mutation ExecuteWorkflowStep($workflowId: ID!, $input: ExecuteStepInput!) {
        executeStep(workflowId: $workflowId, input: $input) {
            id
            reference {
                ...Reference
            }
            errors {
                field
                key
                message
            }
        }
    }
    ${ReferenceFragment}
`;

export const fetchWorkflowQuery: TypedDocumentNode<Pick<Query, 'workflow'>, QueryWorkflowArgs> = gql`
    query FetchWorkflow($id: ID!) {
        workflow(Id: $id) {
            identity {
                id
            }
            status
            context {
                entityReference {
                    ...Reference
                }
                documentReferences {
                    ...Reference
                }
            }
            coverNote
            workflowSteps {
                role
                canAct
                alternateId {
                    label
                    value
                    url
                }
                isSequential
                workflowParticipant {
                    contacts {
                        ...Contact
                    }
                }
                workflowStepResult {
                    actor {
                        ...Contact
                    }
                    result
                    comment
                    occurredAt
                }
            }
            notifyTo {
                ...Contact
            }
            security {
                allowedActions
            }
        }
    }
    fragment Contact on Contact {
        name {
            ...Name
        }
        contactInfo {
            ...ContactInfo
        }
        personReference {
            ...Reference
        }
    }
    ${ContactInfoFragment}
    ${NameFragment}
    ${ReferenceFragment}
`;
